import Config from "../config";
import convertPHPDateFormat from "./convertPHPDateFormat";

const getUserDateFormat = (type = 'moment') => {
    return Config.user.date_format
        ? convertPHPDateFormat(Config.user.date_format, type)
        : 'DD.MM.YYYY';
};

export default getUserDateFormat;